import React, { Component } from 'react';
import { ExtendedFormCategoriesContainer, ExtendedFormContainer } from './containers';
import FAQ from './components/FAQ';
import SuggestionsExtendedStore from './stores/SuggestionsExtendedStore';
import { SuggestionsExtendedActionCreators } from './actions';

class SuggestionsExtendedApp extends Component {
  constructor(props) {
    super(props);

    SuggestionsExtendedStore.setData();
  }

  state = {
    submitStatus: SuggestionsExtendedStore.getSubmitStatus(),
    showFaq: SuggestionsExtendedStore.getShowFaq(),
  };

  componentDidMount() {
    SuggestionsExtendedStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    SuggestionsExtendedStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      submitStatus: SuggestionsExtendedStore.getSubmitStatus(),
      showFaq: SuggestionsExtendedStore.getShowFaq(),
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const emptyAnswers = SuggestionsExtendedStore.getFormDataEmptyAnswers();
    const emailError = SuggestionsExtendedStore.getEmailError();

    if (emptyAnswers.length || emailError) {
      if (emptyAnswers.length) {
        SuggestionsExtendedStore.updateEmptyAnswersErrors(emptyAnswers);
      }
      SuggestionsExtendedStore.setShowErrors(true);
      SuggestionsExtendedStore.emitChange();
      return;
    }

    SuggestionsExtendedStore.setSubmitStatus('loading');
    SuggestionsExtendedStore.emitChange();
    SuggestionsExtendedActionCreators.submitForm();
  };

  render() {
    const { submitStatus, showFaq } = this.state;

    const loading = submitStatus === 'loading';

    return (
      <div className="block tac">
        <div className={loading ? 'loading' : ''}>
          {loading && (
            <div className="loading-spinner loading-spinner--vcenter" />
          )}
          <ExtendedFormCategoriesContainer />
          <ExtendedFormContainer
            onSubmit={this.handleSubmit}
            submitStatus={submitStatus}
          />
        </div>
        <div className={!showFaq ? 'hide' : ''}>
          <FAQ />
        </div>
      </div>
    );
  }
}

export default SuggestionsExtendedApp;
